import { provideAppInitializer, inject } from '@angular/core';
import { LanguageStateService } from '../services/language-state.service';

export function provideLanguage() {
  return provideAppInitializer(() => {
    const languageState = inject(LanguageStateService);
    return languageState.load();
  });
}